import api from './api';

// Типы для позиций
// В реальном проекте эти типы должны быть в types/index.ts
interface PositionBase {
  title: string;
  description?: string;
  level: number;
  next_position_id?: number;
}

interface Position extends PositionBase {
  id: number;
  created_at: string;
  updated_at?: string;
}

interface AchievementPositionBase {
  position_id: number;
  achievement_id: number;
  is_required: boolean;
  // order_index удален
}

interface AchievementPosition extends Omit<AchievementPositionBase, 'order_index'> {
  id: number;
  created_at: string;
}

export const positionsAPI = {
  // CRUD для позиций
  getPositions: async (): Promise<Position[]> => {
    const response = await api.get('/positions/');
    return response.data;
  },

  getPosition: async (positionId: number): Promise<Position> => {
    const response = await api.get(`/positions/${positionId}`);
    return response.data;
  },

  createPosition: async (positionData: PositionBase): Promise<Position> => {
    const response = await api.post('/positions/', positionData);
    return response.data;
  },

  updatePosition: async (positionId: number, positionData: PositionBase): Promise<Position> => {
    const response = await api.put(`/positions/${positionId}`, positionData);
    return response.data;
  },

  deletePosition: async (positionId: number): Promise<void> => {
    await api.delete(`/positions/${positionId}`);
  },

  // Связи позиций с ачивками
  getPositionAchievements: async (positionId: number): Promise<AchievementPosition[]> => {
    const response = await api.get(`/positions/${positionId}/achievements`);
    return response.data;
  },

  addAchievementToPosition: async (positionId: number, achievementData: { achievement_id: number; is_required: boolean }): Promise<AchievementPosition> => {
    // order_index удален из параметров
    const response = await api.post(`/positions/${positionId}/achievements`, achievementData);
    return response.data;
  },

  removeAchievementFromPosition: async (positionId: number, achievementId: number): Promise<void> => {
    await api.delete(`/positions/${positionId}/achievements/${achievementId}`);
  },

  // Получить должности для дашборда
  getAllPositionsForDashboard: async (): Promise<Array<{id: number, title: string, level: number, description?: string}>> => {
    const response = await api.get('/dashboard/positions');
    return response.data;
  },

  // Получить должности для выбора следующей (отфильтрованные)
  getAvailablePositionsForSelection: async (): Promise<Position[]> => {
    // Этот endpoint возвращает должности, которые еще не являются next_position_id
    const response = await api.get('/positions/');
    return response.data;
  },
};

export type { Position, PositionBase, AchievementPosition, AchievementPositionBase };